import { mdiChevronLeft, mdiChevronRight, mdiDeleteOutline, mdiPencilOutline } from '@mdi/js';
import Icon from '@mdi/react';
import moment from 'moment-jalaali';
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ListS from '../../UI/ListS/ListS';
import useHttp from '../../../hooks/http';
import { showError } from '../../../store';

// const types2 = {
//   EVP_RFL: ['تبخیر', 'بارش'],
//   temp: ['دمای حداکثر', 'دمای متوسط', 'دمای حداقل'],
//   snow: ['ارتفاع', 'چگالی', 'عمق'],
// };

const WeatherList2 = (props) => {
  const [List, setList] = useState();
  const [Range, setRange] = useState(1);
  const { isLoading, data, error, sendRequest, clear } = useHttp();
  const token = useSelector((state) => state.auth.Token);
  const dispatch = useDispatch();
  const setMessage = useCallback(
    (mess) => {
      dispatch(showError(mess));
    },
    [dispatch]
  );

  const ItemPerPage = useRef(10);

  const { url2, type, types2, list2 } = props;

  useEffect(() => {
    sendRequest(url2, 'GET', null, { Authorization: `Bearer ${token}` });
  }, [sendRequest, token, url2]);

  useEffect(() => {
    if (!isLoading && !error && data) {
      console.log(data);
      setList(data);

      clear();
    }
  }, [error, isLoading, data, clear, setMessage]);

  const theList = useMemo(() => {
    if (List) {
      const array = [];

      for (let i = (Range - 1) * ItemPerPage.current; i < Range * ItemPerPage.current && i < List.length; i++) {
        array.push(List[i]);
      }

      return array.map((e, i) => (
        <ul key={e.code}>
          {list2 && list2.map((element) => <li key={element.en}>{e[element.en]}</li>)}
          {types2 && types2[type].map((element) => <li key={element.en}>{e[element.en]}</li>)}
          <li>{moment(e.date).format('jYYYY/jMM/jDD')}</li>
          <li className='edit'>
            <Icon path={mdiPencilOutline} />
          </li>
          <li className='trash'>
            <Icon path={mdiDeleteOutline} />
          </li>
        </ul>
      ));
    }
  }, [Range, List, type, types2, list2]);

  const PageRange = useMemo(() => {
    return (
      <div className='pageRange'>
        <div>صفحه قبل</div>
        <div>
          <div>
            <Icon size={1} path={mdiChevronLeft} onClick={() => setRange((pre) => (pre === 1 ? pre : pre - 1))} />
          </div>
          <div>{Range}</div>
          <div>
            <Icon
              size={1}
              path={mdiChevronRight}
              onClick={() => setRange((pre) => (List[Range * ItemPerPage.current] ? pre + 1 : pre))}
            />
          </div>
        </div>
        <div>صفحه بعد</div>
      </div>
    );
  }, [Range, setRange, List]);

  return (
    <ListS>
      <ul>
        {types2 && types2[type].map((e) => <li key={e.en}>{e.fa}</li>)}
        {list2 && list2.map((e) => <li key={e.en}>{e.fa}</li>)}
        <li>تاریخ</li>
        <li className='edit'>
          <Icon path={mdiPencilOutline} />
        </li>
        <li className='trash'>
          <Icon path={mdiDeleteOutline} />
        </li>
      </ul>
      {theList}
      {PageRange}
    </ListS>
  );
};

export default WeatherList2;
